import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { NavLink } from 'react-router-dom'

import style from '@src/pages/BlockService/BlockService.module.scss'
import { SubscribeBlock } from '@src/components/SubscribeBlock/SubscribeBlock'
import { selectUserServices } from '@src/store/ducks/user/selectors'
import { Modal } from '@src/components/common/Modal/Modal'
import { Datepicker } from '@src/components/common/Datepicker/Datepicker'
import { Button } from '@src/components/Button/Button'
import { AppDispatch } from '@src/store/store'
import {
  blockTariff, getBlockDescription, getBlockTariffs, getFreeBlockDays, unblockTariff,
} from '@src/store/ducks/tariffs/thunks'
import {
  selectTariffBlockDescription,
  selectTariffBlockTariffs,
  selectTariffsFreeBlockDays,
  selectTariffsIsLoadingBlock,
  selectTariffsIsSuccessBlock,
} from '@src/store/ducks/tariffs/selectors'
import { resetTariffs, setIsSuccessBlock } from '@src/store/ducks/tariffs/reducer'
import { AvailableTariff } from '@src/store/ducks/tariffs/types'

export const FreeBlocking = () => {
  const dispatch = useDispatch<AppDispatch>()
  const services = useSelector(selectUserServices)
  const freeBlockDays = useSelector(selectTariffsFreeBlockDays)
  const isLoadingBlock = useSelector(selectTariffsIsLoadingBlock)
  const isSuccessBlock = useSelector(selectTariffsIsSuccessBlock)
  const blockTariffs = useSelector(selectTariffBlockTariffs)
  const description = useSelector(selectTariffBlockDescription)
  // const [show, setShow] = useState(false)
  const [selectTariff, setSelectTariff] = useState<null | AvailableTariff>(null)
  const [date, setDate] = useState({
    startDate: '',
    endDate: '',
  })

  useEffect(() => () => {
    dispatch(resetTariffs())
  }, [dispatch])

  useEffect(() => {
    if (services.tariff) {
      dispatch(getBlockDescription())
      dispatch(getBlockTariffs())
    }
  }, [dispatch, services.tariff])

  useEffect(() => {
    console.log('--- DEBUG selectTariff ---', selectTariff)
    // Если нужно увидеть весь объект подробно:
    if (selectTariff) {
      console.table(selectTariff)
    }
  }, [selectTariff])

  const selectedDays = useMemo(() => {
    if (date.startDate && date.endDate) {
      return moment(date.endDate, 'DD.MM.YYYY').diff(moment(date.startDate, 'DD.MM.YYYY'), 'days') + 1
    }
    return null
  }, [date])

  const isValidate = useMemo(() => (
    !!selectedDays && (selectedDays > 6 || freeBlockDays < 7)
  ), [freeBlockDays, selectedDays])

  const handleOpen = useCallback((data: AvailableTariff) => {
    dispatch(getFreeBlockDays(data.deviceId))
    setDate({ startDate: '', endDate: '' })
    setSelectTariff(data)
  }, [dispatch])

  const handleClose = useCallback(() => {
    if (!isLoadingBlock) {
      setSelectTariff(null)
      dispatch(setIsSuccessBlock(false))
    }
  }, [isLoadingBlock, dispatch])

  const handleBlock = useCallback(() => {
    if (selectTariff) dispatch(blockTariff(date.startDate, date.endDate, selectTariff.deviceId))
  }, [selectTariff, dispatch, date.startDate, date.endDate])

  return (
    <>
      <div>
        <div className={cn(style.textBlock, style.showText)}>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        {/* <button
          type="button"
          className={style.other_functions}
          onClick={() => {
            setShow(!show)
          }}
        >
          {!show ? 'Читать полностью' : 'Скрыть текст'}
        </button> */}
        <div className={style.tariffPlans}>
          <h3>Ваши тарифные планы</h3>
          {blockTariffs.map((item) => (
            <SubscribeBlock
              key={item.goodId}
              btnName={item.block ? 'Разблокировать' : 'Блокировать'}
              title={(
                <div>
                  <div>{item.goodName}</div>
                  {item.block && (
                    <div className={style.tariffPlans_active}>
                      Активна
                      {' '}
                      {item?.block.dateStart.trim() && (
                        <>
                          с
                          {' '}
                          {moment(item.block.dateStart, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm')}
                        </>
                      )}
                      {item.block.dateEnd.trim() && (
                        <>
                          {' '}
                          до
                          {' '}
                          {moment(item.block.dateEnd, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY HH:mm')}
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
              btn
              btnDisabled={isLoadingBlock}
              btnClick={() => {
                if (item.block) {
                  dispatch(unblockTariff(item.block.serviceId))
                } else {
                  handleOpen(item)
                }
              }}
              className="styleNull"
            />
          ))}
        </div>
      </div>

      <Modal isOpen={!!selectTariff} close={handleClose}>
        {isSuccessBlock ? (
          <>
            <div className={style.modalTitle}>Услуга успешно заблокирована</div>
            <NavLink to="/">
              <Button className={style.btnPosition} type="primary">
                В личный кабинет
              </Button>
            </NavLink>
          </>
        ) : (
          <>
            <div className={style.modalTitle}>Выберите период блокировки</div>

            <div className={style.modalDescription}>
              Остаток бесплатной блокировки, дней -
              {' '}
              <span>
                {freeBlockDays}
              </span>
            </div>

            <Datepicker date={date} setDate={setDate} minDate={moment().add(1, 'day').format()} />

            {selectedDays && (
              <div className={style.daysBlock}>
                <div className={style.days}>
                  <span>Выбрано, дней: </span>
                  <span>{selectedDays}</span>
                </div>
                {freeBlockDays > 0 && (
                  <div className={style.days}>
                    <span>Бесплатно, дней: </span>
                    <span>{selectedDays > freeBlockDays ? freeBlockDays : selectedDays}</span>
                  </div>
                )}
                {(selectedDays - freeBlockDays > 0) && (
                  <div className={style.days}>
                    <span>
                      Платно, дней (
                      {selectTariff?.price}
                      {' '}
                      руб./мес.
                      ):
                      {' '}
                    </span>
                    <span>{selectedDays - freeBlockDays}</span>
                  </div>
                )}
              </div>
            )}

            {!!selectedDays && !isValidate && (
              <div className={style.blockError}>
                Минимальный период блокировки 7 дней
              </div>
            )}

            <Button
              className={style.btnPosition}
              type="primary"
              onClickFunc={handleBlock}
              loading={isLoadingBlock}
              disabled={!isValidate}
            >
              Блокировать
            </Button>
          </>
        )}
      </Modal>
    </>
  )
}
